module.exports = __webpack_public_path__ + "img/amalia.77b1a9d8.png";